import BlogList from "components/blog/BlogList";
import CTA from "components/home/CTA";
import FAQs from "components/home/FAQs";
import Header from "components/home/Header";
import Incentives from "components/home/Incentives";
import LogoCloud from "components/home/LogoCloud";
import FutureSection from "components/home/FutureSection";
import FullWidthLayout from "hocs/layouts/FullWidthLayout";
import { useEffect } from "react";
import { connect } from "react-redux";
import { get_blog_list, get_blog_list_page } from "redux/actions/blog";
import VirtualAssistantSection from "components/home/VirtualAsistent";
import QualificationSection from "components/home/QualificationSection";
import HowItWorks from "components/home/HowItWorks";
import About from "components/home/About";
import ChatBubble from "./Chat";

function Home({
    blog_list,
    get_blog_list,
    get_blog_list_page
}){

    useEffect(()=>{
        blog_list ? <></>:get_blog_list()
        
    },[])

    return(
        <FullWidthLayout>
            <Header/>
            <LogoCloud />
            {/* <FutureSection /> */}
            {/* <VirtualAssistantSection /> */}
            {/* <QualificationSection /> */}
            <About />
            {/* <CTA/> */}
            <ChatBubble />
            {/* <HowItWorks /> */}
            
        </FullWidthLayout>
    )
}

const mapStateToProps = state =>({
    blog_list: state.blog.blog_list
})

export default connect(mapStateToProps,{
    get_blog_list,
    get_blog_list_page
})(Home)